/**
 * Encode a value for a single URL path segment.
 * Group codes and similar identifiers may contain "/", spaces, or other reserved chars.
 */
export function encodePathSegment(value) {
  return encodeURIComponent(String(value ?? "").trim());
}
